<template>
    <div style="margin-top: 50px">
        <h1>Reset Password</h1>
        <PasswordResetForm :errors="errors" @submit-form="submitForm" />
    </div>
</template>

<script>
import { useUserStore } from "../../stores/userStore";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import PasswordResetForm from "js/components/forms/PasswordResetForm";

export default {
    name: "PasswordReset",
    components: {
        PasswordResetForm,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            store: null,
            triggered: false,
        };
    },
    mounted() {
        if (!this.$route.params.token) {
            this.$router.replace("/login");
        }
        this.store = useUserStore();
    },
    methods: {
        submitForm(data) {
            data.token = this.$route.params.token;
            this.store
                .create("/api/reset-password", data)
                .then((result) => {
                    if (result) {
                        this.$router.replace("/login");
                    }
                })
                .catch(this.handleResponseErrors);
        },
    },
};
</script>
